import { ProTable } from '@ant-design/pro-components';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  OPERATION_ANALYSIS_PAGE_SIZE,
  formatAnalysisAmount,
  formatAnalysisProfitRate,
} from '../utils/operation-analysis';

const createSortableColumn = ({ dataIndex, render, sortField, sortOrder, title }) => ({
  align: 'right',
  dataIndex,
  render,
  sortDirections: ['descend', 'ascend', 'descend'],
  sorter: true,
  sortOrder: sortField === dataIndex ? sortOrder : null,
  title,
});

const createColumns = (current, getStoreLink, sortField, sortOrder) => [
  {
    title: '排名',
    key: 'rank',
    width: 72,
    render: (_, __, index) => (current - 1) * OPERATION_ANALYSIS_PAGE_SIZE + index + 1,
  },
  {
    title: '门店',
    dataIndex: 'name',
    render: (name, record) => {
      const to = record.operationEntityId ? getStoreLink(record) : undefined;
      return to ? <Link to={to}>{name}</Link> : name;
    },
  },
  createSortableColumn({
    dataIndex: 'storeIncomeAmount',
    render: formatAnalysisAmount,
    sortField,
    sortOrder,
    title: '门店总收入（含店外档口）',
  }),
  createSortableColumn({
    dataIndex: 'stallIncomeAmount',
    render: formatAnalysisAmount,
    sortField,
    sortOrder,
    title: '档口总收入',
  }),
  createSortableColumn({
    dataIndex: 'expenseRate',
    render: formatAnalysisProfitRate,
    sortField,
    sortOrder,
    title: '费用率（%）',
  }),
];

const OperationAnalysisStoreRank = ({
  current,
  dataSource,
  getStoreLink,
  loading,
  onPageChange,
  onSortChange,
  sortField,
  sortOrder,
  total,
}) => (
  <ProTable
    columns={createColumns(current, getStoreLink, sortField, sortOrder)}
    dataSource={dataSource}
    headerTitle="门店排行"
    loading={loading}
    locale={{ emptyText: '暂无可访问门店' }}
    options={{ density: false, fullScreen: false, reload: false }}
    pagination={{
      current,
      pageSize: OPERATION_ANALYSIS_PAGE_SIZE,
      showSizeChanger: false,
      total,
      onChange: (page) => onPageChange(page),
    }}
    rowKey="id"
    scroll={{ x: 'max-content' }}
    search={false}
    onChange={(_, __, sorter, extra) => {
      if (extra.action !== 'sort') {
        return;
      }
      const nextSorter = Array.isArray(sorter) ? sorter.find(({ order }) => order) : sorter;
      if (nextSorter?.field) {
        const nextOrder =
          nextSorter.order ||
          (nextSorter.field === sortField && sortOrder === 'ascend' ? 'descend' : 'ascend');
        onSortChange(nextSorter.field, nextOrder);
      }
    }}
  />
);

OperationAnalysisStoreRank.propTypes = {
  current: PropTypes.number.isRequired,
  dataSource: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      operationEntityId: PropTypes.string,
      expenseRate: PropTypes.number,
      stallIncomeAmount: PropTypes.number,
      storeIncomeAmount: PropTypes.number,
    }),
  ).isRequired,
  getStoreLink: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onSortChange: PropTypes.func.isRequired,
  sortField: PropTypes.oneOf(['storeIncomeAmount', 'stallIncomeAmount', 'expenseRate']).isRequired,
  sortOrder: PropTypes.oneOf(['ascend', 'descend']).isRequired,
  total: PropTypes.number.isRequired,
};

export default OperationAnalysisStoreRank;
